import React, {useEffect, useState} from 'react';
import {CloseOutlined, LoadingOutlined, UploadOutlined} from '@ant-design/icons';
import {Col, message, Row, Upload as AntDUpload} from 'antd';
import type { UploadChangeParam } from 'antd/es/upload';
import type { RcFile, UploadFile, UploadProps } from 'antd/es/upload/interface';
import {useJCommonContext} from "../../JCommonProvider";

export type JUploadFileProps = {

    /**
     * text show upload or move file
     */
    label?: string;

    /**
     * text File size requirement
     */
    txtSizeRequirement?: string;

    /**
     * file list
     */
    setListFile: (b:string[])=> void;

    /**
     * accept (example image/png,image/jpeg, .pdf)
     */
    accept?: string;

    /**
     * name
     */
    name?: string;

    /**
     * disabled
     */
    disabled?: boolean;

    /**
     * show Upload List up box
     */
    showUploadList?: boolean;

    /**
     * show Down Upload List box
     */
    showDownUploadList?: boolean;

    /**
     * ant design Input props
     * https://ant.design/components/upload/#API
     */
    props?: UploadProps;


};

const getBase64 = (img: RcFile, callback: (url: string) => void) => {
    const reader = new FileReader();
    reader.addEventListener('load', () => callback(reader.result as string));
    reader.readAsDataURL(img);
};

const beforeUpload = (file: RcFile, accept: string) => {
    const acceptArray = accept?.split(',');

    const isJpgOrPng = acceptArray?.filter( accept => (accept === '.pdf') || (accept ===  file?.type ));
    //const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'application/pdf';
    if (!isJpgOrPng) {
        message.error('You can only upload' + accept +' file!');
    }
    const isLt2M = file.size / 1024 / 1024 < 2;
    if (!isLt2M) {
        message.error('Image must smaller than 2MB!');
    }
    return isJpgOrPng && isLt2M;
};

export const JUploadFile = ({
                                accept = 'image/png,image/jpeg,.pdf',
                                disabled= false,
                                name='avatar',
                                label,
                                txtSizeRequirement,
                                setListFile,
                                showUploadList = false,
                                showDownUploadList = true,
                                props
                            }: JUploadFileProps) => {
    const [loading, setLoading] = useState(false);
    const [imageUrlList, setImageUrlList] = useState<string[]>([]);
    const {getImageURL} = useJCommonContext();

    const handleChange: UploadProps['onChange'] = (info: UploadChangeParam<UploadFile>) => {
        if (info?.file?.status === 'uploading') {
            setLoading(true);
            return;
        }
        if (info?.file?.status === 'done') {
            getBase64(info?.file?.originFileObj as RcFile, (url) => {
                setLoading(false);
                setImageUrlList(imageUrlList.concat(url));
            });
        }
    };


    const uploadButton = (
        <div>
            {loading ? <LoadingOutlined aria-hidden={true} /> : <UploadOutlined aria-hidden={true}/>}
            <div style={{ marginTop: 8 }}>{label}</div>
        </div>
    );

    const removePhoto = (indexToRemove: number) => {
        setImageUrlList(imageUrlList.filter((_el: string, i: number) => indexToRemove != i));
    }

    useEffect(()=>{
        setListFile(imageUrlList);
    },[imageUrlList])

    return (
        <>
            <AntDUpload
                {...props}
                aria-hidden={true}
                disabled={disabled}
                accept={accept}
                name={name}
                showUploadList={showUploadList}
                listType="picture-card"
                className="img-upload"
                customRequest={({ onSuccess })=>{
                    setTimeout(() => {
                        onSuccess && onSuccess("ok");
                    }, 1000);
                }}
                beforeUpload={(e)=>beforeUpload(e, accept)}
                onChange={handleChange}
            >
                {uploadButton}
            </AntDUpload>
            <div>
                <small>
                    {txtSizeRequirement}
                </small>
            </div>
            {
                showDownUploadList && imageUrlList.length > 0 &&
                <Row className={'photo-list'}>
                    {
                        imageUrlList.map((url, index) => (
                            <Col className={'selected-photo'}>
                                <div className={'remove-photo'} onClick={() => removePhoto(index)}>
                                    <CloseOutlined aria-hidden={true}/>
                                </div>
                                <div className={'image-content'}>
                                    <img src={getImageURL(url)} aria-hidden={true}/>
                                </div>
                            </Col>
                        ))
                    }
                </Row>
            }
        </>
    );
};
